var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"name__box text-center p-1"},[_c('input',{directives:[{name:"focus",rawName:"v-focus"}],attrs:{"type":"text","placeholder":"Scrivi il tuo nome..."},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.blurra()},"focusout":function($event){_vm.$emit('select', _vm.ok, $event.target.value)}}})])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a788889","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./src/component/game/question/text/text.html
// module id = 414
// module chunks = 0